// removed by extract-text-webpack-plugin
module.exports = {"container":"SummaryBoxContainer-container","label":"SummaryBoxContainer-label"};